import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/core";
import { cn } from "@/shared/lib/cn";

export interface TopbarAuthLinksProps {
  className?: string;
}

/**
 * Lo que ocupa el sitio del menú de la cuenta cuando no hay nadie dentro.
 *
 * Son ENLACES, no botones: `as={Link}` hace que sean `<a href>` de
 * verdad, así que funcionan la rueda del ratón, "abrir en pestaña nueva"
 * y el menú contextual, y el lector de pantalla los anuncia como enlaces
 * — que es lo que son.
 *
 * "Crear cuenta" se esconde bajo `sm`: en un teléfono no cabe junto al
 * título y al selector de idioma, y desde el acceso se llega igual.
 */
export function TopbarAuthLinks({ className }: TopbarAuthLinksProps) {
  const { t } = useTranslation();

  return (
    <div className={cn("flex shrink-0 items-center gap-2", className)}>
      <Button
        as={Link}
        to="/login"
        variant="ghost"
        size="sm"
        leftIcon={<LogIn />}
        className="h-9 border-ds-border bg-white/70"
      >
        {t("Iniciar sesión")}
      </Button>
      <Button as={Link} to="/register" variant="primary" size="sm" className="hidden h-9 sm:inline-flex">
        {t("Crear cuenta")}
      </Button>
    </div>
  );
}
